import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import MajorItem from "./MajorItem";
import SubItem from "./SubItem";
import { AdDatabaseSVG } from "../../../assets/img/AdDatabaseSVG";
import { AdOffericonSVG } from "../../../assets/img/AdOffericonSVG";
import { AdProjecticonSVG } from "../../../assets/img/AdProjecticonSVG";
import { AdSchooliconSVG } from "../../../assets/img/AdSchooliconSVG";
import { AdAdminiconSVG } from "../../../assets/img/AdAdminiconSVG";
import { useAppSelector } from "../../../redux/hooks";
import { getRoles } from "../../../redux/reducers/user";
import { IconCalendarSVG } from "../../../assets/img/iconCalendarSVG";

type Props = {
  isSideBarOpen: boolean;
};

const JikeiMenu: React.FC<Props> = (props) => {
  const { pathname } = useLocation();
  const roles = useAppSelector(getRoles);

  const { isSideBarOpen } = props;

  const [currentMenu, setCurrentMenu] = useState<number>(0);

  const toggleMenu = (i: number) => {
    if (i === currentMenu) {
      setCurrentMenu(0);
    } else {
      setCurrentMenu(i);
    }
  };

  useEffect(() => {
    if (
      pathname.includes("/jikei/student") ||
      pathname.includes("/jikei/portfolio") ||
      pathname.includes("/jikei/team") ||
      pathname.includes("/jikei/release")
    ) {
      setCurrentMenu(1);
    } else if (pathname.includes("/jikei/offer")) {
      setCurrentMenu(2);
    } else if (pathname.includes("/jikei/project")) {
      setCurrentMenu(3);
    } else if (pathname.includes("/jikei/event")) {
      setCurrentMenu(4);
    } else if (
      pathname.includes("/jikei/school") ||
      pathname.includes("/jikei/course")
    ) {
      setCurrentMenu(5);
    } else if (pathname.includes("/jikei/manager")) {
      setCurrentMenu(6);
    }
  }, []);

  return (
    <>
      <MajorItem
        icon={<AdDatabaseSVG width={30} height={30} />}
        header="データベース"
        isOpen={currentMenu == 1 ? true : false}
        sideBarOpen={isSideBarOpen}
        handleMenu={() => toggleMenu(1)}
      >
        <SubItem
          link="/jikei/student"
          title="学生一覧"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          link="/jikei/portfolio"
          title="プロフィール一覧"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          link="/jikei/team"
          title="チーム一覧"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          link="/jikei/release"
          title="公開申請"
          sideBarOpen={isSideBarOpen}
        />
      </MajorItem>
      <MajorItem
        link="/jikei/offer"
        icon={<AdOffericonSVG width={30} height={30} />}
        header="オファー"
        isOpen={currentMenu == 2 ? true : false}
        sideBarOpen={isSideBarOpen}
        handleMenu={() => toggleMenu(2)}
      />
      <MajorItem
        link=""
        icon={<AdProjecticonSVG width={30} height={30} />}
        header="プロジェクト"
        isOpen={currentMenu == 3 ? true : false}
        sideBarOpen={isSideBarOpen}
        handleMenu={() => toggleMenu(3)}
      >
        <SubItem
          link="/jikei/project"
          title="プロジェクト一覧"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          link="/jikei/project/release"
          title="公開申請"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          link="/jikei/project/application"
          title="応募申請"
          sideBarOpen={isSideBarOpen}
        />
      </MajorItem>
      <MajorItem
        header="イベント"
        icon={<IconCalendarSVG width={30} height={30} />}
        isOpen={currentMenu == 4 ? true : false}
        sideBarOpen={isSideBarOpen}
        handleMenu={() => toggleMenu(4)}
      >
        <SubItem
          title="イベント一覧"
          link="/jikei/event"
          sideBarOpen={isSideBarOpen}
        />
        <SubItem
          title="公開申請"
          link="/jikei/event/release"
          sideBarOpen={isSideBarOpen}
        />
      </MajorItem>
      {roles?.includes("jikei_admin") ? (
        <>
          <MajorItem
            icon={<AdSchooliconSVG width={30} height={30} />}
            header="学校"
            isOpen={currentMenu == 5 ? true : false}
            sideBarOpen={isSideBarOpen}
            handleMenu={() => toggleMenu(5)}
          >
            <SubItem
              link="/jikei/school"
              title="学校一覧"
              sideBarOpen={isSideBarOpen}
            />
            <SubItem
              link="/jikei/course"
              title="コース一覧"
              sideBarOpen={isSideBarOpen}
            />
          </MajorItem>
          <MajorItem
            link="/jikei/manager"
            icon={<AdAdminiconSVG width={30} height={30} />}
            header="管理者一覧"
            isOpen={currentMenu == 6 ? true : false}
            sideBarOpen={isSideBarOpen}
            handleMenu={() => toggleMenu(6)}
          />
        </>
      ) : null}
    </>
  );
};

export default JikeiMenu;
